import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", { class: "m-bottom-35 t-a-c" }, "Contact us", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_input = _resolveComponent("base-input")!
  const _component_base_textarea = _resolveComponent("base-textarea")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, {
    class: "modal-contact-us",
    onClose: _ctx.closeModal
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createVNode(_component_base_input, {
        class: "m-bottom-15",
        title: "Add your name",
        placeholder: "Name",
        errors: _ctx.errors.name,
        value: _ctx.form.name,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.name) = $event))
      }, null, 8, ["errors", "value"]),
      _createVNode(_component_base_input, {
        class: "m-bottom-15",
        title: "Add your e-mail",
        placeholder: "E-mail",
        errors: _ctx.errors.email,
        value: _ctx.form.email,
        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.email) = $event))
      }, null, 8, ["errors", "value"]),
      _createVNode(_component_base_textarea, {
        title: "Write your message",
        placeholder: "Message",
        errors: _ctx.errors.msg,
        value: _ctx.form.msg,
        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.msg) = $event))
      }, null, 8, ["errors", "value"]),
      _createElementVNode("button", {
        class: "btn m-top-20",
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.send && _ctx.send(...args)))
      }, "Send message")
    ]),
    _: 1
  }, 8, ["onClose"]))
}